// Web interface languages. Content/profile languages may have a wider scope.
export const WEB_LANGUAGES = Object.freeze([
  { code: "fr", label: "FR", name: "Français" },
  { code: "en", label: "EN", name: "English" },
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "nl", label: "NL", name: "Nederlands" },
  { code: "es", label: "ES", name: "Español" },
]);
export const SUPPORTED_WEB_LANGUAGES = WEB_LANGUAGES.map(({ code }) => code);

export const normalizeWebLanguage = (language) => {
  const code = String(language || "").toLowerCase().split(/[-_]/)[0];
  return SUPPORTED_WEB_LANGUAGES.includes(code) ? code : "en";
};

/** First supported browser preference (including regional tags), otherwise English. */
export const detectBrowserWebLanguage = (browser = typeof navigator !== "undefined" ? navigator : null) => {
  const preferences = [...(browser?.languages || []), browser?.language];
  for (const preference of preferences) {
    const code = String(preference || "").trim().toLowerCase().split(/[-_]/)[0];
    if (SUPPORTED_WEB_LANGUAGES.includes(code)) return code;
  }
  return "en";
};
